(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  var VEHICLE_STORAGE_KEY = 'fitment-lab-vehicle';
  var FITMENT_KEYS = ['year', 'make', 'model', 'trim', 'engine'];
  var initializedFinders = new WeakSet();
  var toastTimer = null;
  var lastDrawerTrigger = null;

  function route(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    root = root.charAt(root.length - 1) === '/' ? root : root + '/';
    return root + String(path || '').replace(/^\//, '');
  }

  function parseJsonResponse(response) {
    return response.json().catch(function () { return {}; }).then(function (payload) {
      if (!response.ok) {
        var message = payload.description || payload.message || payload.error || 'Something went wrong. Please try again.';
        throw new Error(message);
      }
      return payload;
    });
  }

  function requestJson(url, options) {
    var requestOptions = options || {};
    requestOptions.credentials = 'same-origin';
    requestOptions.headers = Object.assign({
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }, requestOptions.headers || {});
    return fetch(url, requestOptions).then(parseJsonResponse);
  }

  function readVehicle() {
    try {
      var value = JSON.parse(window.localStorage.getItem(VEHICLE_STORAGE_KEY) || 'null');
      return value && typeof value === 'object' ? value : null;
    } catch (error) {
      return null;
    }
  }

  function vehicleValue(vehicle, key) {
    if (!vehicle) return '';
    if (vehicle.values && vehicle.values[key]) return String(vehicle.values[key]);
    if (key === 'engine') return String(vehicle.engine || vehicle.modification || vehicle.drive || '');
    return String(vehicle[key] || '');
  }

  function vehicleDisplayValue(vehicle, key) {
    if (!vehicle) return '';
    if (vehicle.labels && vehicle.labels[key]) return String(vehicle.labels[key]);
    if (key === 'make') return String(vehicle.makeLabel || vehicle.make || '');
    if (key === 'model') return String(vehicle.modelLabel || vehicle.model || '');
    if (key === 'trim') return String(vehicle.trimLabel || vehicle.trim || '');
    if (key === 'engine') return String(vehicle.engineLabel || vehicle.drive || vehicle.engine || vehicle.modification || '');
    return String(vehicle[key] || '');
  }

  function vehicleLabel(vehicle) {
    if (!vehicle) return '';
    if (vehicle.label) return String(vehicle.label);
    return [vehicleCore(vehicle), vehicleDetails(vehicle)].filter(Boolean).join(' · ');
  }

  function vehicleCore(vehicle) {
    return ['year', 'make', 'model'].map(function (key) {
      return vehicleDisplayValue(vehicle, key);
    }).filter(Boolean).join(' ');
  }

  function vehicleDetails(vehicle) {
    return ['trim', 'engine'].map(function (key) {
      return vehicleDisplayValue(vehicle, key);
    }).filter(Boolean).join(' · ');
  }

  function saveVehicle(vehicle) {
    try {
      window.localStorage.setItem(VEHICLE_STORAGE_KEY, JSON.stringify(vehicle));
    } catch (error) {
      // Storage can be disabled. The current page still remains usable.
    }
    renderVehicleState(vehicle);
    document.dispatchEvent(new CustomEvent('fitment:vehicle-change', { detail: vehicle }));
  }

  function clearVehicle() {
    try {
      window.localStorage.removeItem(VEHICLE_STORAGE_KEY);
    } catch (error) {
      // Ignore unavailable storage.
    }
    renderVehicleState(null);
    document.dispatchEvent(new CustomEvent('fitment:vehicle-change', { detail: null }));
    updateCartVehicleAttribute('').catch(function () {});
  }

  function ensureToast() {
    var toast = document.querySelector('[data-toast]');
    if (toast) return toast;

    toast = document.createElement('div');
    toast.className = 'co-toast';
    toast.setAttribute('data-toast', '');
    toast.setAttribute('role', 'status');
    toast.hidden = true;
    var message = document.createElement('span');
    var dismiss = document.createElement('button');
    dismiss.type = 'button';
    dismiss.setAttribute('aria-label', 'Dismiss');
    dismiss.textContent = '×';
    toast.appendChild(message);
    toast.appendChild(dismiss);
    document.body.appendChild(toast);
    return toast;
  }

  function announce(message, timeout) {
    var toast = ensureToast();
    var target = toast.querySelector('span');
    if (target) target.textContent = message;
    toast.hidden = false;
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toast.hidden = true;
    }, typeof timeout === 'number' ? timeout : 4500);
  }

  function hideToast(toast) {
    if (!toast) return;
    toast.hidden = true;
    window.clearTimeout(toastTimer);
  }

  function fitmentCandidates(vehicle, key) {
    var values = [vehicleValue(vehicle, key), vehicleDisplayValue(vehicle, key)].filter(Boolean);
    return values.filter(function (value, index) { return values.indexOf(value) === index; });
  }

  function FitmentFinder(root) {
    this.root = root;
    this.selects = Array.prototype.slice.call(root.querySelectorAll('[data-fitment-select]'));
    this.submit = root.querySelector('[data-fitment-submit]');
    this.error = root.querySelector('[data-fitment-error]');
    this.baseUrl = root.getAttribute('data-base-url') || route('collections/all');
    this.placeholders = this.selects.map(function (select) {
      return select.options.length ? select.options[0].textContent.trim() : 'SELECT';
    });
    this.controller = null;
    this.bind();
    this.initialize();
  }

  FitmentFinder.prototype.bind = function () {
    var finder = this;
    this.selects.forEach(function (select, index) {
      select.addEventListener('change', function () { finder.change(index); });
    });
    if (this.submit) {
      this.submit.addEventListener('click', function () { finder.go(); });
    }
  };

  FitmentFinder.prototype.url = function (throughIndex, includeView) {
    var url = new URL(this.baseUrl, window.location.origin);
    this.selects.forEach(function (select) {
      url.searchParams.delete(select.getAttribute('data-param'));
    });
    this.selects.slice(0, throughIndex + 1).forEach(function (select) {
      if (select.value) url.searchParams.set(select.getAttribute('data-param'), select.value);
    });
    if (includeView) url.searchParams.set('view', 'fitment');
    else url.searchParams.delete('view');
    return url;
  };

  FitmentFinder.prototype.showError = function (message) {
    if (!this.error) return;
    this.error.textContent = message || '';
    this.error.hidden = !message;
  };

  FitmentFinder.prototype.reset = function (index) {
    for (var i = index; i < this.selects.length; i += 1) {
      var select = this.selects[i];
      select.innerHTML = '';
      select.add(new Option(this.placeholders[i], ''));
      select.disabled = true;
    }
  };

  FitmentFinder.prototype.setBusy = function (busy) {
    this.root.setAttribute('aria-busy', busy ? 'true' : 'false');
  };

  FitmentFinder.prototype.load = async function (index, preferredValues) {
    var select = this.selects[index];
    if (!select) return false;

    if (this.controller) this.controller.abort();
    var controller = new AbortController();
    this.controller = controller;
    select.disabled = true;
    select.innerHTML = '';
    select.add(new Option('LOADING ' + this.placeholders[index] + '…', ''));
    this.setBusy(true);
    this.showError('');

    try {
      var response = await fetch(this.url(index - 1, true).toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
        signal: controller.signal
      });
      if (!response.ok) throw new Error('Vehicle options could not be loaded.');
      var documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      var sourceSelector = select.getAttribute('data-source');
      var source = sourceSelector ? documentFragment.querySelector(sourceSelector) : null;
      if (!source) throw new Error('Vehicle data is not configured for this collection.');

      var unique = new Map();
      Array.prototype.slice.call(source.options).forEach(function (option) {
        var value = String(option.value || '').trim();
        var label = String(option.textContent || value).trim();
        if (value && !unique.has(value)) unique.set(value, label || value);
      });
      var options = Array.from(unique, function (entry) { return { value: entry[0], label: entry[1] }; });
      options.sort(function (a, b) {
        if (index === 0 && !Number.isNaN(Number(a.value)) && !Number.isNaN(Number(b.value))) {
          return Number(b.value) - Number(a.value);
        }
        return a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' });
      });

      select.innerHTML = '';
      select.add(new Option(this.placeholders[index], ''));
      options.forEach(function (option) { select.add(new Option(option.label, option.value)); });
      select.disabled = options.length === 0;

      var candidates = Array.isArray(preferredValues) ? preferredValues : [];
      var match = options.find(function (option) {
        return candidates.some(function (candidate) {
          return option.value.toLowerCase() === String(candidate).toLowerCase()
            || option.label.toLowerCase() === String(candidate).toLowerCase();
        });
      });
      if (match) select.value = match.value;
      if (!options.length) this.showError('No matching ' + this.placeholders[index].toLowerCase() + ' options were found.');
      return Boolean(match || options.length);
    } catch (error) {
      if (error && error.name === 'AbortError') return false;
      select.innerHTML = '';
      select.add(new Option(this.placeholders[index], ''));
      select.disabled = true;
      this.showError(error && error.message ? error.message : 'Vehicle options could not be loaded.');
      return false;
    } finally {
      if (this.controller === controller) {
        this.controller = null;
        this.setBusy(false);
      }
      this.updateSubmit();
    }
  };

  FitmentFinder.prototype.initialize = async function () {
    var saved = readVehicle();
    for (var index = 0; index < this.selects.length; index += 1) {
      var candidates = saved ? fitmentCandidates(saved, FITMENT_KEYS[index]) : [];
      await this.load(index, candidates);
      if (!this.selects[index].value) {
        this.reset(index + 1);
        break;
      }
    }
    this.updateSubmit();
  };

  FitmentFinder.prototype.change = async function (index) {
    this.reset(index + 1);
    this.showError('');
    this.updateSubmit();
    if (this.selects[index].value && this.selects[index + 1]) {
      await this.load(index + 1, []);
    }
  };

  FitmentFinder.prototype.updateSubmit = function () {
    if (!this.submit) return;
    this.submit.disabled = !this.selects.length || !this.selects.every(function (select) {
      return Boolean(select.value);
    });
  };

  FitmentFinder.prototype.selection = function () {
    var values = {};
    var labels = {};
    this.selects.forEach(function (select, index) {
      var key = FITMENT_KEYS[index];
      var option = select.options[select.selectedIndex];
      values[key] = select.value;
      labels[key] = option ? option.textContent.trim() : select.value;
    });
    var destination = this.url(this.selects.length - 1, false);
    return {
      version: 1,
      values: values,
      labels: labels,
      year: values.year,
      make: values.make,
      makeLabel: labels.make,
      model: values.model,
      modelLabel: labels.model,
      trim: values.trim,
      trimLabel: labels.trim,
      engine: values.engine,
      engineLabel: labels.engine,
      modification: values.engine,
      drive: labels.engine,
      label: [
        [labels.year, labels.make, labels.model].filter(Boolean).join(' '),
        [labels.trim, labels.engine].filter(Boolean).join(' · ')
      ].filter(Boolean).join(' · '),
      url: destination.pathname + destination.search,
      savedAt: new Date().toISOString()
    };
  };

  FitmentFinder.prototype.go = async function () {
    if (!this.selects.every(function (select) { return Boolean(select.value); })) {
      this.showError('Choose a complete vehicle before shopping.');
      return;
    }
    var vehicle = this.selection();
    saveVehicle(vehicle);
    this.submit.disabled = true;
    this.submit.textContent = 'SAVING YOUR RIDE…';
    try {
      await updateCartVehicleAttribute(vehicle.label);
    } catch (error) {
      // A saved vehicle and filtered destination do not depend on cart attributes.
    }
    window.location.assign(vehicle.url);
  };

  function initializeFinders(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('fitment-finder').forEach(function (root) {
      if (initializedFinders.has(root)) return;
      initializedFinders.add(root);
      new FitmentFinder(root);
    });
  }

  function renderVehicleState(vehicle) {
    var saved = vehicle || readVehicle();
    document.querySelectorAll('[data-vehicle-property]').forEach(function (input) {
      input.value = saved ? vehicleLabel(saved) : '';
    });

    document.querySelectorAll('[data-product-vehicle]').forEach(function (box) {
      var number = box.querySelector('div > span');
      var small = box.querySelector('small');
      var strong = box.querySelector('strong');
      var button = box.querySelector('button');
      box.classList.toggle('confirmed', Boolean(saved));
      if (number) number.textContent = saved ? '✓' : '01';
      if (small) small.textContent = saved ? 'FITMENT SELECTED FOR' : 'VERIFY YOUR FITMENT';
      if (strong) strong.textContent = saved ? vehicleLabel(saved) : 'ADD YOUR VEHICLE';
      if (button) button.textContent = saved ? 'CHANGE →' : 'SELECT →';
    });

    var container = document.querySelector('[data-saved-ride]');
    var garage = document.querySelector('[data-garage-drawer]');
    if (!container || !garage) return;
    var empty = garage.querySelector('[data-garage-empty]');
    var addLink = garage.querySelector('a.co-drawer-primary');
    container.innerHTML = '';

    if (!saved) {
      if (empty) empty.hidden = false;
      if (addLink) addLink.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;
    if (addLink) addLink.hidden = true;
    var card = document.createElement('div');
    card.className = 'co-saved-ride';
    var eyebrow = document.createElement('small');
    eyebrow.textContent = 'ACTIVE VEHICLE';
    var title = document.createElement('strong');
    title.textContent = vehicleCore(saved) || vehicleLabel(saved);
    var details = document.createElement('span');
    details.textContent = vehicleDetails(saved);
    card.appendChild(eyebrow);
    card.appendChild(title);
    if (details.textContent) card.appendChild(details);
    container.appendChild(card);

    var shop = document.createElement('a');
    shop.className = 'co-drawer-primary';
    shop.href = saved.url || route('collections/all');
    shop.innerHTML = 'SHOP THIS VEHICLE <span>→</span>';
    container.appendChild(shop);

    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'co-remove';
    remove.setAttribute('data-remove-vehicle', '');
    remove.textContent = 'REMOVE VEHICLE';
    container.appendChild(remove);
  }

  function renderCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (count) {
      count.textContent = cart.item_count;
    });
    document.querySelectorAll('[data-cart-heading]').forEach(function (heading) {
      heading.textContent = cart.item_count + ' ITEM' + (cart.item_count === 1 ? '' : 'S');
    });

    document.querySelectorAll('[data-cart-lines]').forEach(function (lines) {
      lines.innerHTML = '';
      cart.items.forEach(function (item) {
        var row = document.createElement('div');
        var name = document.createElement('span');
        var title = item.product_title || item.title || 'Product';
        if (item.variant_title && item.variant_title !== 'Default Title') title += ' · ' + item.variant_title;
        if (item.quantity > 1) title += ' × ' + item.quantity;
        name.textContent = title;
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.setAttribute('data-cart-remove', item.key);
        remove.textContent = 'REMOVE';
        row.appendChild(name);
        row.appendChild(remove);
        lines.appendChild(row);
      });
    });

    document.querySelectorAll('[data-cart-empty]').forEach(function (empty) {
      empty.hidden = cart.item_count > 0;
    });
    document.querySelectorAll('[data-cart-checkout]').forEach(function (checkout) {
      checkout.hidden = cart.item_count === 0;
    });

    renderUpsell(cart);
  }

  /* ------------------------------------------------------------------ *
   * Cart upsell (req #5)
   *
   * Scope note, deliberate: the brief asked for TPMS / lug-nut upsells.
   * The catalogue contains ZERO of those SKUs — verified twice against the
   * storefront; every apparent hit is a fuzzy match on a wheel titled
   * "8 LUG" or a tire. Offering an add-on that cannot be added to a cart is
   * the opposite of "dummy proof", so this ships the one pairing the
   * catalogue can actually honour: wheels in cart, no tires -> offer tires.
   * When accessory SKUs exist, add them to UPSELL_RULES; nothing else changes.
   *
   * Classifier is `product_type`, which is clean on this store:
   * wheels 250/250 "Wheels", tires 250/250 "Tires" (sampled products.json).
   * ------------------------------------------------------------------ */
  var UPSELL_RULES = [
    {
      id: 'tires',
      has: 'wheels',
      missing: 'tires',
      headline: 'ADD TIRES TO YOUR WHEELS',
      body: 'Mounted, balanced and road-force tested before we ship — one box, ready to bolt on.',
      cta: 'SHOP MATCHING TIRES',
      href: '/collections/tires'
    },
    {
      id: 'wheels',
      has: 'tires',
      missing: 'wheels',
      headline: 'NEED WHEELS TO MATCH?',
      body: 'Pick a wheel that fits your ride and we will mount this set to it before it ships.',
      cta: 'SHOP WHEELS',
      href: '/collections/wheels'
    }
  ];

  function cartKinds(cart) {
    var kinds = {};
    (cart.items || []).forEach(function (item) {
      var t = (item.product_type || '').toLowerCase();
      if (t.indexOf('wheel') === 0) kinds.wheels = true;
      else if (t.indexOf('tire') === 0) kinds.tires = true;
      else if (t.indexOf('suspension') === 0) kinds.suspension = true;
    });
    return kinds;
  }

  function renderUpsell(cart) {
    var hosts = document.querySelectorAll('[data-cart-upsell]');
    if (!hosts.length) return;
    var kinds = cartKinds(cart);
    var rule = null;
    for (var i = 0; i < UPSELL_RULES.length; i++) {
      if (kinds[UPSELL_RULES[i].has] && !kinds[UPSELL_RULES[i].missing]) {
        rule = UPSELL_RULES[i];
        break;
      }
    }
    hosts.forEach(function (host) {
      if (!rule) { host.hidden = true; host.innerHTML = ''; return; }
      if (host.getAttribute('data-rendered') === rule.id) { host.hidden = false; return; }
      host.innerHTML = '';
      var small = document.createElement('small');
      small.textContent = 'COMPLETE YOUR SETUP';
      var h3 = document.createElement('h3');
      h3.textContent = rule.headline;
      var p = document.createElement('p');
      p.textContent = rule.body;
      var a = document.createElement('a');
      a.href = rule.href;
      a.textContent = rule.cta;
      // textContent throughout: cart data is user-influenced, never innerHTML it
      host.appendChild(small);
      host.appendChild(h3);
      host.appendChild(p);
      host.appendChild(a);
      host.setAttribute('data-rendered', rule.id);
      host.hidden = false;
    });
  }

  function refreshCart() {
    return requestJson(route('cart.js')).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  function updateCartVehicleAttribute(label) {
    return requestJson(route('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Fitment vehicle__': label || '' } })
    }).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  function overlayIsOpen() {
    return Array.prototype.some.call(document.querySelectorAll('[data-cart-drawer], [data-garage-drawer]'), function (drawer) {
      return !drawer.hidden;
    });
  }

  function syncOverlayState() {
    var open = overlayIsOpen();
    document.body.classList.toggle('fitment-overlay-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }

  function openDrawer(drawer, trigger) {
    if (!drawer) return;
    closeDrawers(false);
    lastDrawerTrigger = trigger || document.activeElement;
    drawer.hidden = false;
    var dialog = drawer.querySelector('.co-drawer');
    if (dialog) {
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
    }
    syncOverlayState();
    var close = drawer.querySelector('[data-drawer-close]');
    if (close) window.setTimeout(function () { close.focus(); }, 0);
  }

  function closeDrawers(restoreFocus) {
    document.querySelectorAll('[data-cart-drawer], [data-garage-drawer]').forEach(function (drawer) {
      drawer.hidden = true;
    });
    syncOverlayState();
    if (restoreFocus !== false && lastDrawerTrigger && typeof lastDrawerTrigger.focus === 'function') {
      lastDrawerTrigger.focus();
    }
    lastDrawerTrigger = null;
  }

  function setChat(open) {
    var panel = document.querySelector('[data-chat-panel]');
    if (!panel) return;
    panel.hidden = !open;
    document.querySelectorAll('[data-chat-toggle]').forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (open) {
      var close = panel.querySelector('[data-chat-close]');
      if (close) close.focus();
    }
  }

  function closeMenus() {
    var nav = document.querySelector('[data-main-nav]');
    var menuToggle = document.querySelector('[data-menu-toggle]');
    var shopToggle = document.querySelector('[data-shop-toggle]');
    var shopMenu = document.querySelector('[data-shop-menu]');
    if (nav) nav.classList.remove('open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    if (shopToggle) shopToggle.setAttribute('aria-expanded', 'false');
    if (shopMenu) shopMenu.hidden = true;
  }

  function setFormBusy(form, busy) {
    var button = form.querySelector('button[type="submit"]');
    if (!button) return;
    var label = button.querySelector('span') || button;
    if (busy) {
      if (!label.getAttribute('data-original-label')) label.setAttribute('data-original-label', label.textContent);
      label.textContent = 'ADDING…';
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
    } else {
      var original = label.getAttribute('data-original-label');
      if (original) label.textContent = original;
      button.disabled = false;
      form.removeAttribute('aria-busy');
    }
  }

  async function addFormToCart(form) {
    var vehicle = readVehicle();
    var vehicleInput = form.querySelector('[data-vehicle-property]');
    if (vehicleInput) vehicleInput.value = vehicle ? vehicleLabel(vehicle) : '';
    var formData = new FormData(form);
    if (vehicle && !formData.has('properties[_Vehicle]')) {
      formData.append('properties[_Vehicle]', vehicleLabel(vehicle));
    }

    setFormBusy(form, true);
    try {
      await requestJson(route('cart/add.js'), { method: 'POST', body: formData });
      var cart = await refreshCart();
      var product = form.closest('.fitment-product-card, [data-product-root]');
      var title = product && product.querySelector('h1, h3');
      announce((title ? title.textContent.trim() : 'Item') + ' added to your cart.');
      openDrawer(document.querySelector('[data-cart-drawer]'), form.querySelector('button[type="submit"]'));
      return cart;
    } finally {
      setFormBusy(form, false);
    }
  }

  function updateVariant(select) {
    var root = select.closest('[data-product-root]') || document;
    var option = select.options[select.selectedIndex];
    if (!option) return;
    root.querySelectorAll('[data-product-price], [data-product-button-price]').forEach(function (price) {
      if (option.getAttribute('data-price')) price.textContent = option.getAttribute('data-price');
    });
    var variantImage = option.getAttribute('data-image');
    var mainImage = root.querySelector('.fitment-pdp-image');
    if (variantImage && mainImage) {
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = variantImage;
    }
    var submit = root.querySelector('[data-product-form] button[type="submit"]');
    if (submit) {
      submit.disabled = option.disabled;
      var label = submit.querySelector('span');
      if (label) label.textContent = option.disabled ? 'SOLD OUT' : 'ADD TO BAG';
    }
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (error) {
      // Variant selection still works when History API access is restricted.
    }
  }

  function selectProductImage(button) {
    var root = button.closest('[data-product-root]');
    if (!root) return;
    var image = root.querySelector('.fitment-pdp-image');
    var source = button.getAttribute('data-image');
    if (!image || !source) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = source;
    root.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
      thumb.classList.toggle('active', thumb === button);
    });
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-product-thumb]'));
    var index = thumbs.indexOf(button);
    var counter = root.querySelector('.pdp-image-index');
    if (counter && index >= 0) {
      counter.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(thumbs.length).padStart(2, '0');
    }
  }

  function toggleFaq(button) {
    var targetId = button.getAttribute('aria-controls') || button.getAttribute('data-faq-toggle');
    var panel = targetId ? document.getElementById(targetId) : button.nextElementSibling;
    if (!panel) return;
    var open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
  }

  function handleClick(event) {
    var target = event.target;
    var menuToggle = target.closest('[data-menu-toggle]');
    if (menuToggle) {
      var nav = document.querySelector('[data-main-nav]');
      var open = nav ? !nav.classList.contains('open') : false;
      if (nav) nav.classList.toggle('open', open);
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var shopToggle = target.closest('[data-shop-toggle]');
    if (shopToggle) {
      var shopMenu = document.querySelector('[data-shop-menu]');
      var shopOpen = shopMenu ? shopMenu.hidden : false;
      if (shopMenu) shopMenu.hidden = !shopOpen;
      shopToggle.setAttribute('aria-expanded', shopOpen ? 'true' : 'false');
      return;
    }

    var cartOpen = target.closest('[data-cart-open]');
    if (cartOpen) {
      openDrawer(document.querySelector('[data-cart-drawer]'), cartOpen);
      refreshCart().catch(function (error) { announce(error.message); });
      return;
    }

    var garageOpen = target.closest('[data-garage-open]');
    if (garageOpen) {
      renderVehicleState(readVehicle());
      openDrawer(document.querySelector('[data-garage-drawer]'), garageOpen);
      closeMenus();
      return;
    }

    if (target.closest('[data-drawer-close]')) {
      closeDrawers(true);
      return;
    }

    var backdrop = target.closest('[data-cart-drawer], [data-garage-drawer]');
    if (backdrop && target === backdrop) {
      closeDrawers(true);
      return;
    }

    var removeLine = target.closest('[data-cart-remove]');
    if (removeLine) {
      removeLine.disabled = true;
      requestJson(route('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: removeLine.getAttribute('data-cart-remove'), quantity: 0 })
      }).then(function (cart) {
        renderCart(cart);
        announce('Item removed from your cart.');
      }).catch(function (error) {
        removeLine.disabled = false;
        announce(error.message);
      });
      return;
    }

    if (target.closest('[data-remove-vehicle]')) {
      clearVehicle();
      announce('Saved vehicle removed.');
      return;
    }

    var chatToggle = target.closest('[data-chat-toggle]');
    if (chatToggle) {
      var panel = document.querySelector('[data-chat-panel]');
      setChat(panel ? panel.hidden : false);
      return;
    }
    if (target.closest('[data-chat-close]')) {
      setChat(false);
      return;
    }

    var dismiss = target.closest('[data-toast] button');
    if (dismiss) {
      hideToast(dismiss.closest('[data-toast]'));
      return;
    }

    var thumb = target.closest('[data-product-thumb]');
    if (thumb) {
      selectProductImage(thumb);
      return;
    }

    var faq = target.closest('[data-faq-toggle]');
    if (faq) {
      toggleFaq(faq);
      return;
    }

    var mainNav = document.querySelector('[data-main-nav]');
    if (mainNav && mainNav.classList.contains('open') && target.closest('[data-main-nav] a')) {
      closeMenus();
    } else if (!target.closest('[data-main-nav]')) {
      var menu = document.querySelector('[data-shop-menu]');
      var toggle = document.querySelector('[data-shop-toggle]');
      if (menu) menu.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  }

  function handleSubmit(event) {
    var form = event.target.closest('form');
    if (!form || (!form.matches('[data-quick-add]') && !form.matches('[data-product-form]'))) return;
    if (!window.fetch || !window.FormData) return;
    event.preventDefault();
    addFormToCart(form).catch(function (error) {
      announce(error && error.message ? error.message : 'This item could not be added to the cart.');
    });
  }

  function handleChange(event) {
    var select = event.target.closest('[data-variant-select]');
    if (select) updateVariant(select);
  }

  function handleKeydown(event) {
    if (event.key !== 'Escape') return;
    closeDrawers(true);
    setChat(false);
    closeMenus();
  }

  function initialize(scope) {
    initializeFinders(scope || document);
    renderVehicleState(readVehicle());
    (scope || document).querySelectorAll('[data-variant-select]').forEach(updateVariant);
    (scope || document).querySelectorAll('[data-product-root]').forEach(function (root) {
      var firstThumb = root.querySelector('[data-product-thumb]');
      if (firstThumb) firstThumb.classList.add('active');
    });
  }

  document.addEventListener('click', handleClick);
  document.addEventListener('submit', handleSubmit);
  document.addEventListener('change', handleChange);
  document.addEventListener('keydown', handleKeydown);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  window.addEventListener('storage', function (event) {
    if (event.key === VEHICLE_STORAGE_KEY) renderVehicleState(readVehicle());
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
      refreshCart().catch(function () {});
    });
  } else {
    initialize(document);
    refreshCart().catch(function () {});
  }
})();
